import { Component, OnInit } from '@angular/core';
import { TableElementComponent } from '@uranda/ui';

@Component({
    selector: 'app-quote-action-table',
    templateUrl: './quote-action-table.component.html',
    styleUrls: ['./quote-action-table.component.css'],
    standalone: false
})
export class QuoteActionTableComponent extends TableElementComponent {

}
